<template >
  <div class="container-fluid">
    <div class="row">
      <aside class="filter-sidebar col-lg-3 col-md-12 col-sm-12">
        <!-- <div class="card">
          <div class="card-body">
            <h5 class="card-title">فیلتر اتاق ها</h5>
            <hr />
          
                <div class="filter_type">
                <a
                  class="title-tools"
                  data-toggle="collapse"
                  href="#collapseFilters"
                  aria-expanded="false"
                  aria-controls="collapseFilters"
                  id="filters_col_bt"
                >
                  <i  class="icon-warehouse"></i> فیلتر نوع اتاق
                </a>
                <PdkRoomTypeFilter style="font-size:12px;    margin-top: 15px;"
                  v-if="roomsAvail.availableRoomTypes != null"
                  :roomTypes="roomTypes"
                />
                <PdkRoomTypeFilter v-else />
              </div>
            <div class="filter_type">
              <hr />
              <a
                class="title-tools"
                data-toggle="collapse"
                href="#collapseFilters"
                aria-expanded="false"
                aria-controls="collapseFilters"
                id="filters_col_bt"
                style="margin-bottom: 15px;"
              >
                <i class="icon-ok-5"></i> ویژگی اتاق
              </a>

              <ul>
                <li>
                  <CheckBox
                    class="checkBox"
                    type="checkbox"
                    name="airline"
                    value="12"
                    title="همراه با صبحانه"
                  />
                </li>
                <li>
                  <CheckBox
                    class="checkBox"
                    type="checkbox"
                    name="airline"
                    value="12"
                    title="استعمال سیگار"
                  />
                </li>
              </ul>
            </div>
          </div>
        </div> -->
        <div v-if="hotelId === 4" class="card">
          <h4 style="color: #08446a; margin: 14px 28px -20px">
            <i class="icon-location-3"></i>{{ $t("HomeBody.DariushGrandhotel") }} 
          </h4>
          <p style="margin: 28px; text-align: justify; font-size: 13px">
          {{ $t("HomeBody.HotelDariushDescription") }} 
          </p>
          <div style="height: 200px; margin: 15px" class="box_style_2">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d7138.998225657594!2d54.02102266235288!3d26.53622921278214!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3e50aa4d3b680af9%3A0x5a30586d94d7563d!2sDariush%20Grand%20Hotel!5e0!3m2!1sen!2s!4v1614424950134!5m2!1sen!2s"
              width="600" height="450" style="border: 0" allowfullscreen="" loading="lazy"></iframe>
          </div>
        </div>
        <div v-else-if="hotelId === 9" class="card">
          <h4 style="color: #08446a; margin: 14px 28px -20px">
            <i class="icon-location-3"></i> {{ $t("HomeBody.HotelSinour") }} 
          </h4>
          <p style="margin: 28px; text-align: justify; font-size: 13px">
            {{ $t("HomeBody.HotelSinourDescription") }} 
          </p>
          <div style="height: 200px; margin: 15px" class="box_style_2">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3216.557712027459!2d59.61543463488938!3d36.27451541926708!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3f6c972b5ca0de39%3A0x4c3a8d63c3a2d776!2sSinoor%20Hotel!5e0!3m2!1sen!2sde!4v1617519527037!5m2!1sen!2sde"
              width="600" height="450" style="border: 0" allowfullscreen="" loading="lazy"></iframe>
          </div>
        </div>

        <div v-else class="card">
          <h4 style="color: #08446a; margin: 14px 28px -20px">
            <i class="icon-location-3"></i>هتل داریوش کیش
          </h4>
          <p style="margin: 28px; text-align: justify; font-size: 13px">تست</p>
          <div style="height: 200px; margin: 15px" class="box_style_2">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d7138.998225657594!2d54.02102266235288!3d26.53622921278214!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3e50aa4d3b680af9%3A0x5a30586d94d7563d!2sDariush%20Grand%20Hotel!5e0!3m2!1sen!2s!4v1614424950134!5m2!1sen!2s"
              width="600" height="450" style="border: 0" allowfullscreen="" loading="lazy"></iframe>
          </div>
        </div>
        <div class="box_style_2">
          <i class="icon_set_1_icon-57"></i>
          <h4>
            به کمک
            <span>نیاز دارید؟</span>
          </h4>
          <a style="direction: ltr" href="tel://02144631360" class="phone">021-44631360-5</a>
          <a href="tel://0098214411364" class="phone">09045425792 </a>
        </div>
      </aside>

      <div class="avail-container col-lg-9 col-md-8 col-sm-12">
        <div>
          <div class="card p-4">
            <div style="margin-bottom: 60px" class="row">
              <div v-if="!showCombineRoom" class="col-md-6 room-title">
                <h2>پیشنهاد ما برای انتخاب <span>اتاق</span></h2>
              </div>
              <div v-else class="col-md-6 room-title">
                <h2>انتخاب <span>اتاق</span></h2>
              </div>
              <div class="col-md-6" style="text-align: left;padding: 0;">
                <button v-if="!showCombineRoom" @click="combineRoom()" class="button arrow">
                  خودم انتخاب می کنم
                </button>
                <button v-if="showCombineRoom" @click="showCombineRoom = false" class="button arrow">
                  پیشنهاد ما
                </button>
              </div>

              <!-- <button
                v-if="!showCombineRoom"
                class="btn_room"
                @click="combineRoom()"
              >
                خودم انتخاب می کنم
              </button>
              <button
                v-if="showCombineRoom"
                class="btn_room"
                @click="showCombineRoom = false"
              >
                پیشنهاد ما
              </button> -->
            </div>
            <CombiningRoom @selected="onSelectedCombinedRooms($event)" v-if="showCombineRoom"
              :rooms="roomsAvail.availableRoomTypes" />

            <div v-if="!showCombineRoom">
              <div v-for="(option, index) in paginatedRoomsOption" :key="index" class="strip_all_tour_list wow fadeIn"
                data-wow-delay="0.1s" style="
                  visibility: visible;
                  animation-delay: 0.1s;
                  animation-name: fadeIn;
                ">
                <div class="row">
                  <div class="col-lg-9 col-md-9 col-xs-12">
                    <div style="height: auto" class="tour_list_desc">
                      <div class="choice row">
                        <div class="option-title the-icons">
                          <i class="icon-ok filter-icon"></i>
                          <span class="i-name">{{ $t("SearchResults.Select") }}  {{ index + 1 }}</span>
                        </div>
                        <div id="room_combine">
                          <div v-for="(room, roomIndex) in option" :key="roomIndex" class="room">
                            <div class="room-desc">
                              <small id="title">{{ room.name }} <label></label></small>
                              <div id="capacity">
                                 {{ $t("SearchResults.Capacity") }} : <span>{{ room.capacity }}</span>
                              </div>
                              <div id="exterabed">
                               {{ $t("SearchResults.ExtraBedCapacity") }}:
                                <span>{{ room.maximumExtraBed }}</span>
                              </div>
                            </div>
                            <div id="room-feature">
                              <div style="margin-left: 10px" v-if="room.breakfastIncluded === true" class="
                                  tooltip_flip tooltip-effect-1
                                  option
                                  the-icons
                                ">
                                <i class="room-fac-icon icon_set_1_icon-61 filter-icon"></i>

                                <span style="margin-bottom: 29px" class="tooltip-content-flip"><span
                                    class="tooltip-back">{{ $t("SearchResults.Breakfast") }}
                                  </span></span>
                              </div>

                              <div style="margin-left: 10px" v-if="room.smoking === false" class="
                                  tooltip_flip tooltip-effect-1
                                  option
                                  the-icons
                                ">
                                <i style="font-size: 33px" class="room-fac-icon icon_set_1_icon-47 filter-icon"></i>

                                <span style="margin-bottom:29px" class="tooltip-content-flip"><span
                                    style="font-size: 11px" class="tooltip-back">{{ $t("SearchResults.NoSmoking") }}
                                  </span></span>
                              </div>

                              <div style="left: 30px !important" class="
                                  tooltip_position tooltip_flip tooltip-effect-1
                                " v-if="
                                  room.amenities.length > 0 ||
                                  room.description !== ''
                                ">
                                <span style="margin-left: 32px" class="tooltip-content-flip"><span
                                    style="font-size: 11px" class="tooltip-back">{{ $t("SearchResults.RoomDetails") }}</span></span>
                                <div v-if="
                                  !showAmenities[
                                  roomIndex.toString() + index.toString()
                                  ]
                                ">
                                  <div @click="
                                    onShowAmenities(
                                      roomIndex.toString() + index.toString()
                                    )
                                  " class="feature-list the-icons">
                                    <i class="icon-feature icon_set_1_icon-74 filter-icon"></i>
                                    <!-- <span class="i-name">امکانات اتاق</span> -->
                                  </div>
                                </div>
                                <div v-else>
                                  <div @click="
                                    onHideAmenities(
                                      roomIndex.toString() + index.toString()
                                    )
                                  " class="feature-list the-icons">
                                    <i class="icon-feature icon-eye-off filter-icon"></i>
                                    <!-- <span class="i-name">امکانات اتاق</span> -->
                                  </div>
                                </div>
                              </div>

                              <div class="
                                  tooltip_position tooltip_flip tooltip-effect-1
                                ">
                                <span style="margin-left: 32px" class="tooltip-content-flip"><span
                                    style="font-size: 11px" class="tooltip-back">{{ $t("SearchResults.PriceDetails") }}</span></span>
                                <div v-if="
                                  !showPrice[
                                  roomIndex.toString() + index.toString()
                                  ]
                                ">
                                  <div @click="
                                    onShowPrice(
                                      roomIndex.toString() + index.toString()
                                    )
                                  " class="feature-list the-icons">
                                    <i class="icon-feature icon_set_1_icon-35 filter-icon"></i>
                                    <!-- <span class="i-name">امکانات اتاق</span> -->
                                  </div>
                                </div>
                                <div v-else>
                                  <div @click="
                                    onHidePrice(
                                      roomIndex.toString() + index.toString()
                                    )
                                  " class="feature-list the-icons">
                                    <i class="icon-feature icon-eye-off filter-icon"></i>
                                    <!-- <span class="i-name">امکانات اتاق</span> -->
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div></div>
                            <!-- <div  v-if="room.smoking === false" class="option the-icons">
                          <i class="fa fa-home filter-icon"></i>
                          <span class="i-name">سیگار مجاز است</span>
                        </div> amenities -->

                            <transition name="fade">
                              <div v-if="
                                showPrice[
                                roomIndex.toString() + index.toString()
                                ]
                              " class="room-features">
                                <div style="
                                    padding: 10px 40px 10px 10px;
                                    background: #f3f9ff;
                                  ">
                                  <div style="
                                      margin-bottom: 10px;
                                      margin-right: -30px;
                                    " class="row">
                                    <span> {{ $t("SearchResults.PerNight") }} :</span>
                                    <span>
                                      {{ room.basePrice | numFormat | rial }}
                                    </span>
                                  </div>
                                  <div class="row">
                                    <div v-if="room.maximumExtraBed > 0" style="margin-left: 30px" class="row">
                                      <span>{{ $t("SearchResults.َAdultExtraBed") }} : </span>
                                      <span>
                                        {{
                                            room.rackExtraBedPrice
                                            | numFormat
                                            | rial
                                        }}
                                      </span>
                                    </div>
                                    <div v-else style="margin-left: 30px; color: #00c3e1" class="row">
                                      <span> <i class="icon-info-4"></i> </span>
                                      <span>
                                         {{ $t("SearchResults.WithoutExtraServices") }} 
                                      </span>
                                    </div>
                                    <div v-if="room.maximumExtraBed > 0" class="row">
                                      <span>{{ $t("SearchResults.ChildExtraBed") }}  : </span>
                                      <span>
                                        {{
                                            room.rackChildPrice | numFormat | rial
                                        }}
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </transition>

                            <transition name="fade">
                              <div v-if="
                                showAmenities[
                                roomIndex.toString() + index.toString()
                                ]
                              " class="room-features">
                                <div v-if="room.amenities.length > 0">
                                  <i class="icon_color icon-quote-left-alt"></i>
                                  <span id="title"> {{ $t("SearchResults.RoomAvailabilities") }} : </span>
                                  <label v-for="(item, index) in room.amenities" :key="index">{{ item }}
                                    <span style="margin-left: 2px">،</span>
                                  </label>
                                </div>

                                <div class="room_desc" v-if="room.description !== ''">
                                  <i class="icon_color icon-pin"></i>

                                  <span id="title"> {{ $t("SearchResults.Description") }} : </span>
                                  <label>{{ room.description }}</label>
                                </div>
                              </div>
                            </transition>

                            <div v-if="option.length > 1" class="room-divider"></div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-3 col-md-3" style="display: flex; flex-direction: column; justify-content: center;">
                    <div class="room_price"  >
                      <div >
                        <div v-if="showPrice" style="    display: block; padding: 0;">
                        <span class="normal_price_list">{{
                            totalBasePrice(option) | numFormat | rial
                        }}</span>
                        <span>{{
                            totalFarePrice(option) | numFormat | rial
                        }}</span>
                        <small>{{ $t("SearchResults.PerNight") }} </small>
                        </div>


                        <a @click="onSelectRoom(option)" class="cust_btn btn btn-block btn-primary"
                          style="width: auto; margin: auto">{{ $t("SearchResults.Select") }}</a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <button v-if="!showCombineRoom" @click="nextPage()">
              {{ $t("SearchResults.SelectMore") }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import Range from "@/components/PdkRange";
import CheckBox from "@/components/PdkCheckBox";
import dateUtil from "../../utils/date";
import Store from "../../views/tour/store/index";
import CombiningRoom from "./CombiningRooms";
import PdkRoomTypeFilter from "../../components/shared/RoomTypeFilter";
require("linqjs");
require("bootstrap");

export default {
  store: Store,
  name: "SelectRooms",
  props: {
    roomsAvail: {
      type: Array,
      required: true,
      default: () => [],
    },
    showPrice: Boolean,
  },
  components: {
    Range,
    CheckBox,
    CombiningRoom,
    PdkRoomTypeFilter,
  },

  data() {
    return {
      showAmenities: {},
      showPrice: {},
      size: 6,
      pageNumber: 0,
      showCombineRoom: false,
      roomTypes: [],
      hotelId: 0,
    };
  },

  created() {
    this.hotelId = this.$store.getters["Book/GetHotelId"];
    this.selectAllRoomTypes();
  },
  mounted() { },
  methods: {
    selectAllRoomTypes() {
      var arr = [];
      this.roomsAvail.availableRoomTypes.forEach((element) => {
        element[0].forEach((el) => {
          arr.push(el);
        });
      });
      var distntictArray = arr.reduce((seed, current) => {
        return Object.assign(seed, {
          [current.name]: current,
        });
      }, {});
      this.roomTypes = distntictArray;
      "arr distntict roomtype", distntictArray;
    },
    onSelectedCombinedRooms(items) {
      this.$emit("selected", items);
    },
    totalBasePrice: function (values) {
      return values.reduce((acc, val) => {
        return acc + parseInt(val.totalBasePrice);
      }, 0);
    },
    totalFarePrice: function (values) {
      return values.reduce((acc, val) => {
        return acc + parseInt(val.totalFarePrice);
      }, 0);
    },

    onSelectRoom(option) {
      this.$emit("selected", option);
    },
    combineRoom() {
      this.showCombineRoom = true;
    },
    onShowAmenities(id) {
      this.$set(this.showAmenities, id, true);
    },
    onHideAmenities(id) {
      this.$set(this.showAmenities, id, false);
    },

    onShowPrice(id) {
      this.$set(this.showPrice, id, true);
    },
    onHidePrice(id) {
      this.$set(this.showPrice, id, false);
    },
    nextPage() {
      this.pageNumber++;
    },
  },
  computed: {
    paginatedRoomsOption() {
      //   this.size = this.roomsOption.length;
      const start = this.pageNumber * this.size,
        end = start + this.size;
      return this.roomsAvail.availableRooms.slice(0, end);
    },
  },
};
</script>

<style scoped>

@media only screen and (max-width: 768px) {
  .room_price div {
    padding-left: 0px !important;
  }

  .arrow {
    width: auto;
    position: relative !important;
    left: 15px !important;
    background: #fcbe2f;
    margin-top: 15px !important;
  }

  .room_price {
    padding: 10px;
  }
  
  .tour_list_desc {
    border-left: none !important;
  }

}
@media only screen and (max-width: 750px) {
  .room_price div {
    padding-left: 0px !important;
  }
  .room_price{
  margin-top: -22px;
}
}


.strip_all_tour_list.wow.fadeIn {
  padding: 15px !important;
}


.room-title {
  font-size: 16px;
  margin-top: 12px;
}

.room-title h2 {
  text-transform: uppercase;
  font-weight: 600;
  letter-spacing: -1px;
  font-size: 19px;
  margin-bottom: 0;
  margin-top: 0;
}

.room-title h2 span {
  color: #0a6c9f;
}

.cust_btn {
  color: white !important;
  background: #084a6a  !important;
  transition: 0.4s;
  width: 215px;
  margin: auto;
  margin-bottom: 15px;
}

.cust_btn:hover {
  background: #03264d !important;
}

.room_price small {
  font-size: 11px;
  color: #999;
  display: block;
  margin-bottom: 10px;
  line-height: 12px;
}

.room_price div {
  display: table-cell;
  /* vertical-align: middle; */
  text-align: center;
  padding-left: 25px;
}

.room_price {
  margin-left: inherit;
  /* margin-right: -15px; */
}

.room_price {
  display: table;
  /* height: 220px; */
  font-size: 18px;
  color: #217d0d;
  width: 100%;
}

.room_price .normal_price_list {
  display: block;
  text-decoration: line-through;
  color: #999;
  font-size: 20px;
  margin-top: 10px;
}

.feature-list {
  position: absolute;
  left: 0;
  margin-left: 40px;
}

.room-desc {
  display: flex;
}

.room-desc #capacity {
  margin: 0px 5px 0px 5px !important;
  color: #898989d1 !important;
  font-size: 15px !important;
}

.room-desc #exterabed {
  margin: 0px 5px 0px 5px !important;
  color: #898989d1 !important;
  font-size: 15px !important;
}

.room-divider {
  text-align: center;
  height: 1px;
  margin: 10px 0 10px 0;
  background-color: #e1e8ed;
}

.room {
  display: grid;
  padding: 10px 10px 0px 10px;
}

.room #title {
  font-weight: bold;
  color: #0a6c9f;
}

.icon_color {
  color: #0a6c9f;
}

.room .option {
  margin-bottom: 8px !important;
  color: black;
}

#room-feature {
  margin: 19px 0px 10px 0px;
}

.room-features #title {
  color: #777777;
  line-height: 10px !important;
}

.room_desc {
  margin-top: 10px;
  margin-bottom: 10px;
}

.choice {
  display: grid;
}

.option-title i {
  font-size: 17px;
}

.option-title span {
  font-weight: bold;
}

.more-amenities {
  color: #0a6c9f;
  cursor: pointer;
}

#room-feature {
  display: flex;
}

.icon-feature {
  font-size: 24px;
  color: #08446a;
  cursor: pointer;
  transition: 0.4s;
}

.icon-feature:hover {
  font-size: 24px;
  color: #0a6c9f;
  cursor: pointer;
}

.fade-enter-active {
  transition: opacity 1.3s;
}

.fade-leave-active {
  transition: opacity 0s;
}

.fade-enter,
.fade-leave-to

/* .fade-leave-active below version 2.1.8 */
  {
  opacity: 0;
}

.btn_room {
  background: #f0f7ff;
  color: #0a6c9f;
  width: 205px;
  position: absolute;
  left: 0;
  margin-left: 22px;
}

.btn_room:hover {
  background: #c8e0fa;
  color: #dbb85c;
}

.flight_title {
  text-align: center;
  font-size: 16px;
  margin-bottom: 10px;
}

.flight_title h2 {
  text-transform: uppercase;
  font-weight: 600;
  letter-spacing: -1px;
  font-size: 19px;
  margin-bottom: 0;
  margin-top: 0;
}

.flight_title h2 span {
  color: #00c3e1;
}

.component-fade-enter-active,
.component-fade-leave-active {
  transition: opacity 0.3s ease;
}

.component-fade-enter,
.component-fade-leave-to

/* .component-fade-leave-active below version 2.1.8 */
  {
  opacity: 0;
}

.tooltip_position {
  position: absolute;
  left: 0;
}

.room-fac-icon {
  font-size: 26px;
  cursor: pointer;
}

.button {
  display: inline-block;
  -webkit-font-smoothing: antialiased;
  position: relative;
  padding: 0.8em 1.4em;
  padding-right: 4.7em;
  background: #0a6c9f;
  border: none;
  color: white;
  transition: 0.2s;
}

.button:before,
.button:after {
  background: #f3b118;
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  padding-top: inherit;
  padding-bottom: inherit;
  width: 2.8em;
  content: "\00a0";
  font-family: "FontAwesome", sans-serif;
  font-size: 1.2em;
  text-align: center;
  transition: 0.2s;
  transform-origin: 50% 60%;
  border-radius: 50px;
}

.button:hover {
  background: #0079a5;
}

.button:active,
.button:focus {
  background: #002e3f;
  outline: none;
}

.button {
  min-width: 15em;
  border-radius: 55px;
}

.arrow {
  width: auto;
  position: absolute;
  left: 15px;
  background: #fcbe2f;
}

.arrow:hover {
  background: #fcbe2f;
}

.arrow:active,
.arrow:focus {
  background: #fcbe2f;
}

.arrow:after {
  content: "\F054";
}

.arrow:hover:after {
  -webkit-animation: bounceright 0.3s alternate ease infinite;
  animation: bounceright 0.3s alternate ease infinite;
}

@media only screen and (max-width: 750px) {
  .avail-container {
    flex: 0 0 100% !important;
    max-width: 100% !important;
  }

  .filter-sidebar {
    display: none !important;
  }
}

.filter-sidebar {
  flex: 0 0 27%;
  max-width: 27%;
}

.avail-container {
  flex: 0 0 73%;
  max-width: 73%;
}
</style>